export var FinancialsTableGroupBy = /*#__PURE__*/ function(FinancialsTableGroupBy) {
    FinancialsTableGroupBy["Role"] = "ROLES_AND_TEAM_MEMBERS";
    FinancialsTableGroupBy["Phase"] = "PHASES_AND_TASKS";
    FinancialsTableGroupBy["ExpenseBudget"] = "EXPENSE_BUDGET";
    FinancialsTableGroupBy["ExpenseCategory"] = "EXPENSE_CATEGORY";
    FinancialsTableGroupBy["ExpenseReport"] = "EXPENSE_REPORT";
    return FinancialsTableGroupBy;
}({});
export var FinancialsZoomLevel = /*#__PURE__*/ function(FinancialsZoomLevel) {
    FinancialsZoomLevel["Overall"] = "OVERALL";
    FinancialsZoomLevel["Quarterly"] = "QUARTER";
    FinancialsZoomLevel["Monthly"] = "MONTH";
    FinancialsZoomLevel["Period"] = "PERIOD";
    FinancialsZoomLevel["Revenue"] = "REVENUE";
    FinancialsZoomLevel["Profitability"] = "PROFITABILITY";
    return FinancialsZoomLevel;
}({});
export var FinancialsComponentGroup = /*#__PURE__*/ function(FinancialsComponentGroup) {
    FinancialsComponentGroup["Budget"] = "BUDGET";
    FinancialsComponentGroup["Hours"] = "HOURS";
    FinancialsComponentGroup["Expense"] = "EXPENSE";
    return FinancialsComponentGroup;
}({});
export var FinancialsComponentType = /*#__PURE__*/ function(FinancialsComponentType) {
    FinancialsComponentType["BudgetLine"] = "BUDGET_LINE";
    FinancialsComponentType["HoursLine"] = "HOURS_LINE";
    FinancialsComponentType["BudgetBar"] = "BUDGET_BAR";
    FinancialsComponentType["HoursBar"] = "HOURS_BAR";
    FinancialsComponentType["BudgetTable"] = "BUDGET_TABLE";
    FinancialsComponentType["HoursTable"] = "HOURS_TABLE";
    FinancialsComponentType["ExpenseTable"] = "EXPENSE_TABLE";
    return FinancialsComponentType;
}({});
